export const PARTICIPANT = 'participant';
export const CHECKER = 'checker';
export const MANAGER = 'manager';